define(["./core", "./attributes/attr", "./attributes/prop", "./attributes/classes", "./attributes/val"], function (jQuery) {
  "use strict";

  // Return jQuery for attributes-only inclusion
  return jQuery;
});